import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DeliveryStatus, DropdownStatusList, FilterPaymentTypeOptions, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, PageSize, PaymentTypeOptions, RentalOptions, RentalStatusOptions, ReturnConditionOptions, StatusCodeActive, TransactionTypeOptions, TransactionTypeRental, TransactionTypeSales } from "utils/Constant";
import { ApiOrderRentalDelivered } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import Dropdown from "components/Input/Dropdown";
import { CheckResponse, DateLong, GetStatus, money } from "utils/helpers"
import RevisionIcon from "assets/icon/RevisionIcon";
import { useModal } from "components/modal/ModalContext";
import DatePicker from "components/Input/DatePicker";
import { FilterCard, FormCard, PagesTitle } from "components/Cards";
import moment from "moment";
import { useCallApi } from "api/apiHooks";
import Pagination from "components/Input/PaginationButton";
import SmallButton from "components/Button/SmallButton";

export default function Transaction(){
    let navigate = useNavigate()

    const { openModal, closeModal } = useModal()
    const { fetchSalesOrderList, fetchRentalOrderList, fetchReturnRental, fetchDeliverRental } = useCallApi()

    const { fetch: apiOrderRentalDelivered } = useFetch(ApiOrderRentalDelivered)

    const [orderList, setOrderList] = useState([])
    const [rentalOrderList, setRentalOrderList] = useState([])
    const [customerName, setCustomerName] = useState('')
    const [rentalStatus, setRentalStatus] = useState('')
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [transactionType, setTransactionType] = useState('1')
    const [selectedRentalReturn, setSelectedRentalReturn] = useState({})
    const [returnCondition, setReturnCondition] = useState('')
    const [returnNotes, setReturnNotes] = useState('')
    const [returnDate, setReturnDate] = useState(new Date())
    const [showModalRentalReturn, setShowModalRentalReturn] = useState(false)
    const [orderDateFrom, setOrderDateFrom] = useState(new Date())
    const [orderDateTo, setOrderDateTo] = useState(new Date())
    const [paymentType, setPaymentType] = useState(FilterPaymentTypeOptions[0].value)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    // Button Event
    const deleteBtnClick = (id, status) => {
        openModal(ModalTypeConfirmation, {
            onConfirm: () => {
                openModal(ModalTypeLoading)

                
            },
        })
    }
    const transactionClick = (id) => {
        navigate("/transaction-detail?orderId=" + id + "&transactionType=" + transactionType + "&formType=" + FormTypeEdit)
    }
    const rentalReturnBtnClick = (id) => {
        openModal(ModalTypeLoading)

        fetchReturnRental(id, returnCondition, returnNotes, returnDate).then((res) => {
            if (CheckResponse(res)) {
                handlePageChange(0)
            } else {
                openModal(ModalTypeFail, { message: res.message })
            }
        })
    }
    const deliverRentalBtnClick = (id) => {
        openModal(ModalTypeLoading)

        fetchDeliverRental(id).then((res) => {
            if (CheckResponse(res)) {
                handlePageChange(0)
            } else {
                openModal(ModalTypeFail, { message: res.message })
            }
        })
    }

    // Function Grid
    async function handlePageChange(newIndex) {
        try {
            if (transactionType === TransactionTypeSales) {
                const res = await fetchSalesOrderList(orderDateFrom, orderDateTo, paymentType, status, PageSize, newIndex)

                if (CheckResponse(res)) {
                    const totalData = res?.data?.totalData ?? 0;
                    const total = Math.max(1, Math.ceil(totalData / PageSize));

                    setOrderList(res)
                    setTotalPages(total);
                    setPageIndex(newIndex);
                } else {
                    openModal(ModalTypeFail, { message: res.message })
                    return
                } 
            } else if (transactionType === TransactionTypeRental) {
                const res = await fetchRentalOrderList(customerName, rentalStatus, paymentType, status, PageSize, newIndex, '')

                if (CheckResponse(res)) {
                    const totalData = res?.data?.totalData ?? 0;
                    const total = Math.max(1, Math.ceil(totalData / PageSize));

                    setRentalOrderList(res)
                    setTotalPages(total);
                    setPageIndex(newIndex);
                } else {
                    openModal(ModalTypeFail, { message: res.message })
                    return
                } 
            }
        } finally {
            closeModal();
        }
    }

    useEffect(() => {
        handlePageChange(0).then(() => {
            
        })
    },[orderDateFrom, orderDateTo, paymentType, status, transactionType, rentalStatus, customerName])

    return(
        <div className="flex flex-col gap-2 p-2 sm:p-6 text-md">
            <PagesTitle title='Transaction' />

            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full mt-4">
                { transactionType === TransactionTypeSales && 
                    <div className="flex gap-4">
                        <FilterCard title='Date From' width='w-full sm:w-56'>
                            <DatePicker value={orderDateFrom} onChange={setOrderDateFrom} disableClock={true} />
                        </FilterCard>
                        <FilterCard title='Date To' width='w-full sm:w-56'>
                            <DatePicker value={orderDateTo} onChange={setOrderDateTo} disableClock={true} />
                        </FilterCard>
                    </div>
                }
                
                { transactionType === TransactionTypeRental && 
                    <FilterCard title='Customer Name' width='w-full sm:w-56'>
                        <input className="input" value={customerName} onChange={(e) => { setCustomerName(e.target.value.toUpperCase()) }} />
                    </FilterCard>
                }
                
                <FilterCard title='Payment Type' width='w-full sm:w-48'>
                    <Dropdown value={paymentType} options={FilterPaymentTypeOptions} onChange={(e) => { setPaymentType(e.value) }} placeholder='All' />
                </FilterCard>
                <FilterCard title='Status' width='w-full sm:w-36'>
                    <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder='All' />
                </FilterCard>
            </div>

            <div className="flex gap-2 bg-white p-2 shadow-sm rounded-lg border">
                { TransactionTypeOptions.map((x,i) => 
                    <button key={i}
                        className={`${transactionType === x.value ? 'bg-black text-white' : 'bg-white text-black'}
                            px-3 py-1 rounded-full border text-sm
                        `}
                        onClick={() => {setTransactionType(x.value)}}
                    >
                        {x.label}
                    </button>
                )}
                { transactionType === TransactionTypeRental && 
                    <div className="flex gap-2">
                        <div className="border-x mx-4" />
                        { RentalStatusOptions.map((x,i) => 
                            <button key={i}
                                className={`${rentalStatus === x.value ? 'bg-black text-white' : 'bg-white text-black'}
                                    px-3 py-1 rounded-full border text-sm
                                `}
                                onClick={() => {setRentalStatus(x.value)}}
                            >
                                {x.label}
                            </button>
                        )}
                    </div>
                }
                
            </div>
           
            <div className="mt-5 w-full overflow-y-auto sm:border sm:rounded-3xl sm:shadow-sm">
                {transactionType === TransactionTypeSales ? 
                (
                    // SALES
                    <table className="w-full border bg-white">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left px-2">Date</th>
                                <th className="font-semibold text-left px-2">Payment Type</th>
                                <th className="font-semibold text-left px-2">Total Items</th>
                                <th className="font-semibold text-left px-2">Amount</th>
                                <th className="font-semibold text-left px-2">Status</th>
                                <th className="font-semibold w-auto sm:w-24">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            { orderList?.data?.listData?.length === 0 && (
                                <tr className="text-center h-12">
                                <td colSpan={8}>No Data Available</td> 
                                </tr>
                            )}
                            { orderList?.data?.listData?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100 cursor-pointer" key={ i }
                                        onClick={() => { transactionClick(data.orderId) }}
                                    >
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2">
                                            <span>{ DateLong(data.orderDate) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ PaymentTypeOptions.find(x => x.value === String(data.paymentType)).label }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.totalItem }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>Rp { money(data.nettAmount) }</span>
                                        </td>
                                        <td className="px-2 hidden sm:table-cell">
                                            <span>{ GetStatus(data.status) }</span>
                                        </td>
                                        <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                            <button className={`button flex gap-2`} 
                                                onClick={(e) => { 
                                                    e.stopPropagation()
                                                    deleteBtnClick(data.productId, data.status)
                                                }}>
                                                {data.status === StatusCodeActive ? (<TrashIcon className="w-4 fill-white" />) : (<RevisionIcon className="w-4 fill-white" />)}
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                        <tfoot>
                            <tr className="h-11">
                                <td colSpan={4} className="text-right px-2">
                                    <span className="font-semibold">Total</span>
                                </td>
                                <td colSpan={3} className="px-2">
                                    <span className="font-semibold">Rp {money(String(orderList?.data?.totalAmount))}</span>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                )
                :
                (
                    // RENTAL
                    <table className="w-full border bg-white overflow-y-auto">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left px-2">Rental Date</th>
                                <th className="font-semibold text-left px-2">Customer</th>
                                <th className="font-semibold text-left px-2">Items</th>
                                <th className="font-semibold text-left px-2">Duration</th>
                                <th className="font-semibold text-left px-2">Amount</th>
                                <th className="font-semibold text-left px-2">Delivery Status</th>
                                <th className="font-semibold text-left px-2"></th>
                                <th className="font-semibold text-left px-2">Payment Type</th>
                                <th className="font-semibold text-left px-2">Rental Status</th>
                                <th className="font-semibold text-left px-2">Status</th>
                                <th className="font-semibold w-auto sm:w-24">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            { rentalOrderList?.data?.listData?.length === 0 && (
                                <tr className="text-center h-12">
                                    <td colSpan={11}>No Data Available</td> 
                                </tr>
                            )}
                            { rentalOrderList?.data?.listData?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100 cursor-pointer" key={ i }
                                        onClick={() => { transactionClick(data.rentalOrderId) }}
                                    >
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2">
                                            <span>{ moment(data.rentalDate).format("DD MMM YYYY - HH:mm") }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.customerName }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.brandName } { data.productName }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.quantity } { RentalOptions.find(x => x.value === String(data.rentalOptions)).label }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>Rp { money(data.nettAmount) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span 
                                                className={`
                                                    ${data.deliveryStatus === '1' ? 'bg-gray-500 text-white' : 'bg-yellow-400 text-black'} 
                                                    text-xs px-3 py-1 rounded-full
                                                `}
                                            >
                                                { DeliveryStatus.find(x => x.value === data.deliveryStatus).label }
                                            </span>
                                        </td>
                                        <td className="px-2">
                                            <SmallButton
                                                buttonName='Deliver Item'
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    deliverRentalBtnClick(data.rentalOrderId);
                                                }
                                                }
                                                visible={data.deliveryStatus === '1'}
                                                className='bg-black text-white'
                                            />
                                        </td>
                                        <td className="px-2">
                                            <span>{ PaymentTypeOptions.find(x => x.value === String(data.paymentType)).label }</span>
                                        </td>
                                        <td className="px-2 hidden sm:table-cell">
                                            <span>{ RentalStatusOptions.find(x => x.value === data.isReturned).label }</span>
                                        </td>
                                        <td className="px-2 hidden sm:table-cell">
                                            <span>{ GetStatus(data.status) }</span>
                                        </td>
                                        <td className="px-2">
                                            <SmallButton
                                                buttonName='Returned'
                                                onClick={(e) => {
                                                    e.stopPropagation(); 
                                                    setShowModalRentalReturn(true); 
                                                    setSelectedRentalReturn(data)
                                                }}
                                                visible={data.isReturned === '0' && data.deliveryStatus === '2'}
                                                className='bg-black text-white'
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                        <tfoot>
                            <tr className="h-11">
                                <td colSpan={5} className="text-right px-2">
                                    <span className="font-semibold">Total</span>
                                </td>
                                <td colSpan={3} className="px-2">
                                    <span className="font-semibold">Rp {money(String(rentalOrderList?.data?.totalAmount))}</span>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                )}
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />

            {/* MODAL RENTAL RETURN */}
            {showModalRentalReturn && (
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                
                {/* BACKDROP */}
                <div
                    className="absolute inset-0 bg-black/50"
                    onClick={() => setShowModalRentalReturn(false)}
                />

                {/* MODAL BOX */}
                <div className="relative overflow-auto bg-white rounded-xl shadow-lg lg:w-9/12 xl:w-8/12 2xl:w-6/12 p-6 max-h-[90vh] overflow-y-auto">
                    <h2 className="text-xl font-semibold mb-3">
                        Rental Item Return
                    </h2>

                    <div className="flex flex-col gap-3">
                        <FormCard title='Customer'>
                            <span>{selectedRentalReturn.customerName}</span>
                        </FormCard>

                        <FormCard title='Item'>
                            <span>{selectedRentalReturn.brandName} - {selectedRentalReturn.productName}</span>
                        </FormCard>

                        <FormCard title='Return Date'>
                            <DatePicker className='' value={returnDate} onChange={setReturnDate} />
                        </FormCard>

                        <FormCard title='Return Condition'>
                            <div className="flex gap-2">
                                {ReturnConditionOptions.map((data, i) => {
                                    return(
                                        <button className={`rounded-full border px-3 py-1 ${data.value === '' ? 'hidden' : 'block'} ${data.value === returnCondition ? 'bg-black text-white' : 'bg-white text-black'}`}
                                            onClick={() => setReturnCondition(data.value)}
                                        >
                                            {data.label}
                                        </button>
                                    )
                                })}
                            </div>
                        </FormCard>

                        <FormCard title='Return Notes'>
                            <input className="input" value={returnNotes} onChange={(e) => setReturnNotes(e.target.value)} />
                        </FormCard>
                    
                    </div>
                    
                    <div className="flex justify-end gap-3">
                    <button
                        className="px-4 py-2 rounded-full border"
                        onClick={() => setShowModalRentalReturn(false)}
                    >
                        Cancel
                    </button>

                    <button
                        className="px-4 py-2 rounded-full bg-black text-white"
                        onClick={() => {
                            rentalReturnBtnClick(selectedRentalReturn.rentalOrderId);
                            setShowModalRentalReturn(false);
                        }}
                    >
                        Confirm
                    </button>
                    </div>
                </div>
                </div>
            )}
        </div>
    )
}
